import {Simplex as BaseSimplex} from 'services/sports/default/simplex';
import Action from 'actions';
import RuleBuilder from 'services/simplex/rule-builder';
import {getSimplexUnitName, convertSimplexRulesToStr} from 'helpers/simplex-helper';
import {getMapOfLocked} from 'components/organisms/late-swap/helpers';
import {groupObjectsByProp} from 'helpers/array-helper';

export default class SimplexClassic extends BaseSimplex {
    max({incomingValues = {}}) {
        return super.max({
            incomingValues: {
                checkIfPlayerOnDoublePosition: true,
            },
        });
    }

    maxRandom({incomingValues = {}}) {
        return super.maxRandom({
            incomingValues: {
                checkIfPlayerOnDoublePosition: true,
            },
        });
    }

    // positions({incomingValues = {}}) {
    //     const {
    //         sportConfig,
    //         playersData: {preparedPlayers},
    //     } = Action.getState();

    //     let {playersByPos} = incomingValues;

    //     if (isEmpty(playersByPos)) {
    //         playersByPos = preparedPlayers.groupedBy.property('positionName');
    //     }

    //     const configPositions = sportConfig.getConfigProp('positions', []);

    //     const mixedPositions = {};
    //     const playersByPositions = {};

    //     Object.values(configPositions).map((posObj) => {
    //         const allowedPositions = posObj.allowedPositions.map((key) => configPositions[key].shortName);

    //         Object.keys(playersByPos).map((posName) => {
    //             const duplicates = arrayDuplicates(allowedPositions, posName.split('/'));

    //             if (isEmpty(duplicates)) {
    //                 return;
    //             }

    //             if (!mixedPositions.hasOwnProperty(posObj.shortName)) {
    //                 mixedPositions[posObj.shortName] = {};
    //             }

    //             if (!mixedPositions[posObj.shortName].hasOwnProperty(posName)) {
    //                 mixedPositions[posObj.shortName][posName] = {};
    //             }

    //             playersByPos[posName].map((player) => {
    //                 mixedPositions[posObj.shortName][posName][getSimplexUnitName(player.playerId)] = 1;
    //             });
    //         });
    //     });

    //     Object.values(mixedPositions).map((positions) => {
    //         Object.keys(positions).map((posName) => {
    //             playersByPositions[posName] = {...positions[posName]};
    //         });
    //     });

    //     const getRuleForMinUnitsQuantity = function (posKey, mixedPositions) {
    //         const posObj = sportConfig.getPositionByName(posKey, {});

    //         if (isEmpty(posObj)) {
    //             return [];
    //         }

    //         const mixedPosition = mixedPositions[posKey];

    //         let row = {};
    //         Object.values(mixedPosition).map((rows) => {
    //             row = {...row, ...rows};
    //         });

    //         if (isEmpty(row)) {
    //             return [];
    //         }

    //         const ruleBuilder = RuleBuilder.fromAtLeast(posObj.minPlayers);
    //         ruleBuilder.addVars({...row});

    //         const keyPositionRule = ruleBuilder.createRule();

    //         const result = [keyPositionRule];

    //         Object.keys(mixedPosition).map((subPos) => {
    //             if (posKey === subPos) {
    //                 return;
    //             }

    //             const posNames = subPos.split('/');

    //             posNames.map((posName) => {
    //                 if (posKey === posName) {
    //                     return;
    //                 }

    //                 let row = {};
    //                 Object.values(mixedPositions[posName]).map((rows) => {
    //                     row = {...row, ...rows};
    //                 });

    //                 if (!isEmpty(row)) {
    //                     const posObj = sportConfig.getPositionByName(posName, {});

    //                     const ruleBuilder = RuleBuilder.fromAtLeast(posObj.minPlayers + keyPositionRule.obj);
    //                     ruleBuilder.addVars({...row, ...keyPositionRule.row});

    //                     result.push(ruleBuilder.createRule());
    //                 }
    //             });
    //         });

    //         {
    //             let poolOfPositions = [],
    //                 row = {},
    //                 minQuantity = 0;
    //             Object.keys(mixedPosition).map((subPos) => {
    //                 const posNames = subPos.split('/');
    //                 posNames.map((posName) => {
    //                     if (inArray(posName, poolOfPositions)) {
    //                         return;
    //                     }

    //                     poolOfPositions.push(posName);
    //                     const posObj = sportConfig.getPositionByName(posName, {});
    //                     minQuantity += posObj.minPlayers;
    //                     Object.values(mixedPositions[posName]).map((rows) => {
    //                         row = {...row, ...rows};
    //                     });
    //                 });
    //             });

    //             if (!isEmpty(row)) {
    //                 const ruleBuilder = RuleBuilder.fromAtLeast(minQuantity);
    //                 ruleBuilder.addVars({...row});

    //                 result.push(ruleBuilder.createRule());
    //             }
    //         }

    //         return result;
    //     };

    //     const getRuleForMaxUnitsQuantity = function (posKey, mixedPositions) {
    //         let result = [];

    //         const mixedPosition = mixedPositions[posKey];
    //         const positionsStack = {};
    //         let allPlayers = {};

    //         Object.keys(mixedPosition).map((posName) => {
    //             const positions = posName.split('/');
    //             let players = {...mixedPosition[posName]};
    //             let playersQuantity = 0;

    //             allPlayers = {...allPlayers, ...players};
    //             positions.map((pos) => (positionsStack[pos] = 1));

    //             Object.values(configPositions).map((posObj) => {
    //                 const posName = posObj.shortName;

    //                 if (!inArray(posName, positions)) {
    //                     return;
    //                 }

    //                 playersQuantity += posObj.minPlayers;

    //                 if (mixedPositions[posName].hasOwnProperty(posName)) {
    //                     players = {
    //                         ...players,
    //                         ...mixedPositions[posName][posName],
    //                     };
    //                 }
    //             });

    //             if (0 >= playersQuantity) {
    //                 return;
    //             }

    //             const ruleBuilder = RuleBuilder.fromAtMost(playersQuantity);
    //             ruleBuilder.addVars({...players});

    //             result.push(ruleBuilder.createRule());
    //         });

    //         let commonPlayersQuantity = 0;
    //         Object.keys(positionsStack).map((posName) => {
    //             const posObj = sportConfig.getPositionByName(posName, {});
    //             commonPlayersQuantity += posObj.minPlayers;
    //             if (mixedPositions[posName].hasOwnProperty(posName)) {
    //                 allPlayers = {
    //                     ...allPlayers,
    //                     ...mixedPositions[posName][posName],
    //                 };
    //             }
    //         });

    //         if (0 >= commonPlayersQuantity) {
    //             return [...result];
    //         }

    //         const ruleBuilder = RuleBuilder.fromAtMost(commonPlayersQuantity);
    //         ruleBuilder.addVars({...allPlayers});

    //         result.push(ruleBuilder.createRule());

    //         return [...result];
    //     };

    //     const getRuleForMaxMixedUnitsQuantity = function (posKey, mixedPositions) {
    //         let result = [];

    //         const mixedPosition = mixedPositions[posKey];
    //         const keys = Object.keys(mixedPosition);
    //         let positionsLimits = {},
    //             positionsStack = [];

    //         keys.map((posName) => {
    //             const positions = posName.split('/');
    //             positionsStack = [...positionsStack, ...positions];
    //             Object.values(configPositions).map((posObj) => {
    //                 const posName = posObj.shortName;
    //                 if (!inArray(posName, positions)) {
    //                     return;
    //                 }
    //                 positionsLimits[posName] = posObj.maxPlayers;
    //             });
    //         });

    //         let allPlayers = {},
    //             commonPlayersQuantity = 0;
    //         Object.keys(playersByPositions).map((posName) => {
    //             const positions = posName.split('/');
    //             for (let position of positions) {
    //                 if (!inArray(position, positionsStack)) {
    //                     return;
    //                 }
    //             }
    //             allPlayers = {...allPlayers, ...playersByPositions[posName]};
    //         });
    //         Object.values(positionsLimits).map((limit) => {
    //             commonPlayersQuantity += limit;
    //         });

    //         const ruleBuilder = RuleBuilder.fromAtMost(commonPlayersQuantity);
    //         ruleBuilder.addVars({...allPlayers});

    //         result.push(ruleBuilder.createRule());

    //         return [...result];
    //     };

    //     let result = [];
    //     Object.keys(mixedPositions).map((posKey) => {
    //         result = [
    //             ...result,
    //             ...getRuleForMinUnitsQuantity(posKey, cp(mixedPositions)),
    //             ...getRuleForMaxUnitsQuantity(posKey, cp(mixedPositions)),
    //             ...getRuleForMaxMixedUnitsQuantity(posKey, cp(mixedPositions)),
    //         ];
    //     });

    //     return [...result];
    // }

    // alterablePositions({incomingValues = {}}) {
    //     const {
    //         sportConfig,
    //         lateSwap: {csvLineups},
    //         playersData: {games, preparedPlayers},
    //         lineupResolvingProcess,
    //     } = Action.getState();
    //     const playersPool = preparedPlayers.groupedBy.externalId();
    //     const entryId = lineupResolvingProcess.getEntryId();
    //     const lateswapCsvLineup = csvLineups.getOneByEntryId(entryId);
    //     const positionsOrder = sportConfig.getConfigProp('positionsOrder', {});
    //     const mapOfLocked = getMapOfLocked(positionsOrder, lateswapCsvLineup, (player) =>
    //         games.isPlayerGameLocked(player),
    //     );

    //     const indexedPositionsOrder = indexArray(positionsOrder, 'id');

    //     function limitLockedPlayerByLineupPosition(externalId) {
    //         if (!(externalId in playersPool)) {
    //             return;
    //         }

    //         const lineupPositionId = mapOfLocked.players[externalId];

    //         if (!(lineupPositionId in indexedPositionsOrder)) {
    //             return;
    //         }

    //         const {position} = playersPool[externalId];
    //         const {allowedPositions} = indexedPositionsOrder[lineupPositionId];

    //         const playerPositionKeys = arrayDuplicates(position, allowedPositions);

    //         let positionNames = playerPositionKeys.map((positionKey) => {
    //             return sportConfig.getPositionByKey(positionKey).shortName;
    //         });

    //         playersPool[externalId].position = playerPositionKeys;
    //         playersPool[externalId].positionName = positionNames.sort().join('/');
    //     }

    //     Object.keys(mapOfLocked.players).map((externalId) => {
    //         limitLockedPlayerByLineupPosition(externalId);
    //     });

    //     const playersByPos = groupObjectsByProp(playersPool, 'positionName');

    //     return this.exec('positions', {playersByPos}, []);
    // }

    createRulesForPositionOfPlayerThatStaysOnFlex({incomingValues = {}}) {
        const {
            sportConfig,
            lateSwap: {csvLineups},
            playersData: {games, preparedPlayers},
            lineupResolvingProcess,
        } = Action.getState();
        const {unitIdPropName = 'playerId'} = incomingValues;
        const preparedPlayersPool = preparedPlayers.groupedBy.externalId();
        const players = preparedPlayers.groupedBy.allowedPositions();
        const entryId = lineupResolvingProcess.getEntryId();
        const lateswapCsvLineup = csvLineups.getOneByEntryId(entryId);
        const mapOfLocked = getMapOfLocked(
            sportConfig.getConfigProp('positionsOrder', {}),
            lateswapCsvLineup,
            function (player) {
                return games.isPlayerGameLocked(player);
            },
        );

        const combinedPositionsOrderIds = ['G/F', 'F/C', 'flex_1', 'flex_2'];
        const combinedPositionIdsMap = {
            'pg': ['gf'],
            'sg': ['gf'],
            'pf': ['gf', 'fc'],
            'sf': ['gf', 'fc'],
            'c': ['fc'],
        };

        let rules = [];
        combinedPositionsOrderIds.map((positionOrderId) => {
            if (!mapOfLocked.positions.hasOwnProperty(positionOrderId)) {
                return;
            }

            const playerExternalId = mapOfLocked.positions[positionOrderId];

            if (!preparedPlayersPool.hasOwnProperty(playerExternalId)) {
                return;
            }

            const player = preparedPlayersPool[playerExternalId];

            player.position.map((positionKey) => {
                const position = sportConfig.getPositionByKey(positionKey);

                rules = [...rules, ...createRulesForPosition(position, player)];

                const combinedPositionIds = combinedPositionIdsMap[position.id] || [];

                combinedPositionIds.forEach((combinedPositionId) => {
                    const combinedPosition = sportConfig.getPositionById(combinedPositionId);
                    rules = [...rules, ...createRulesForCombinedPosition(combinedPosition, player)];
                });
            });
        });

        function createRulesForCombinedPosition(position, excludablePlayer) {
            const rulesForPosition = createRulesForPosition(position, excludablePlayer);

            rulesForPosition.map((rule) => rule.obj--);

            return rulesForPosition;
        }

        function createRulesForPosition(position, excludablePlayer) {
            if (isEmpty(position)) {
                return [];
            }

            const {allowedPositions} = position;
            const simplexUnitNamesRow = {};
            const addedPlayers = [];

            players.map((player) => {
                if (
                    excludablePlayer.getId() === player.getId() ||
                    !inArray(player.position, allowedPositions) ||
                    inArray(player[unitIdPropName], addedPlayers)
                ) {
                    return;
                }

                simplexUnitNamesRow[getSimplexUnitName(player[unitIdPropName])] = 1;

                addedPlayers.push(player[unitIdPropName]);
            });

            if (isEmpty(simplexUnitNamesRow)) {
                return [];
            }

            const rules = [];

            const atLeastRuleBuilder = RuleBuilder.fromAtLeast(position.minPlayers);
            atLeastRuleBuilder.addVars({...simplexUnitNamesRow});
            rules.push(atLeastRuleBuilder.createRule());

            if (!position.maxPlayers) {
                return rules;
            }

            const atMostRuleBuilder = RuleBuilder.fromAtMost(position.maxPlayers);
            atMostRuleBuilder.addVars({...simplexUnitNamesRow});
            rules.push(atMostRuleBuilder.createRule());

            return rules;
        }

        return [...rules];
    }

    subjectToPermanent() {
        const constraints = {
            players: this.exec('player', {checkIfPlayerOnDoublePosition: true}, []),
            salary: this.exec('salary', {checkIfPlayerOnDoublePosition: true}, []),
            projectedOwnershipCap: this.exec('projectedOwnership', {checkIfPlayerOnDoublePosition: true}, []),
            projectedOwnershipForce: this.exec('forceOfProjectedOwnership', {checkIfPlayerOnDoublePosition: true}, []),
            positions: this.exec('positions', {unitIdPropName: 'uniqueId'}, []),
            teams: this.exec('team', {checkIfPlayerOnDoublePosition: true}, []),
            limitPositions: this.exec('limitPositions', {checkIfPlayerOnDoublePosition: true}, []),
            keyPlayerStacking: this.exec('keyPlayerStacking', {checkIfPlayerOnDoublePosition: true}, []),
            teamNameStacking: this.exec('teamNameStacking', {checkIfPlayerOnDoublePosition: true}, []),
            projectionBoostRule: this.exec('projectionBoostRule', {checkIfPlayerOnDoublePosition: true}, []),
            bound: this.exec('bound', {checkIfPlayerOnDoublePosition: true}, []),
        };

        // Object.keys(constraints).map((key) => {
        //     console.log(`${key}\n`, convertSimplexRulesToStr(constraints[key]));
        // });

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec('playersWhoseGamesAreLocked', {checkIfPlayerOnDoublePosition: true, unitIdPropName: 'uniqueId'}, []),
            createdLineups: this.exec('createdLineups', {checkIfPlayerOnDoublePosition: true}, []),
            multiPositions: this.exec('multiPositions', {}, []),
            exposureMax: this.exec('exposureMax', {checkIfPlayerOnDoublePosition: true}, []),
            exposureMin: this.exec('exposureMin', {checkIfPlayerOnDoublePosition: true}, []),
            playerCombinationStacking: this.exec('playerCombinationStacking', {checkIfPlayerOnDoublePosition: true}, []),
        };

        // Object.keys(constraints).map((key) => {
        //     console.log(`${key}\n`, convertSimplexRulesToStr(constraints[key]));
        // });

        return {...constraints};
    }

    // subjectToPermanent({incomingValues = {}}) {
    //     const {sportConfig} = incomingValues;

    //     const constraints = {
    //         player: this.exec('player', {}, []),
    //         salary: this.exec('salary', {}, []),
    //         projectedOwnershipCap: this.exec('projectedOwnership', {}, []),
    //         projectedOwnershipForce: this.exec('forceOfProjectedOwnership', {}, []),
    //         teams: this.exec('team', {}, []),
    //         keyPlayerStacking: this.exec('keyPlayerStacking', {}, []),
    //         teamNameStacking: this.exec('teamNameStacking', {}, []),
    //         projectionBoostRule: this.exec('projectionBoostRule', {}, []),
    //         bound: this.exec('bound', {}, []),
    //     };

    //     if (!sportConfig.isModeLateswap()) {
    //         constraints.positions = this.exec('positions', {}, []);
    //     }

    //     Object.keys(constraints).map((key) => {
    //         console.log(`${key}\n`, convertSimplexRulesToStr(constraints[key]));
    //     });

    //     return {...constraints};
    // }

    // subjectToAlterable({incomingValues = {}}) {
    //     const {sportConfig} = incomingValues;

    //     const constraints = {
    //         playersWhoseGamesAreLocked: this.exec('playersWhoseGamesAreLocked', {}, []),
    //         createdLineups: this.exec('createdLineups', {}, []),
    //         exposureMax: this.exec('exposureMax', {}, []),
    //         exposureMin: this.exec('exposureMin', {}, []),
    //         playerCombinationStacking: this.exec('playerCombinationStacking', {}, []),
    //     };

    //     if (sportConfig.isModeLateswap()) {
    //         constraints.positions = this.exec('alterablePositions', {}, []);
    //     }

    //     Object.keys(constraints).map((key) => {
    //         console.log(`${key}\n`, convertSimplexRulesToStr(constraints[key]));
    //     });

    //     return {...constraints};
    // }
}
